import { Icon } from 'vopay';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import styles from './PasswordValidationWidget.module.scss';

type PasswordValidationWidgetProps = {
  password: string;
  onValidate: (isValid: boolean) => void;
};

export default function PasswordValidationWidget({ password, onValidate }: PasswordValidationWidgetProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'UI.PasswordValidationWidget' });
  const hasCharcters = password.length >= 8;
  const hasNumber = /\d/g.test(password);
  const hasLowerCase = /[a-z]/g.test(password);
  const hasUpperCase = /[A-Z]/g.test(password);
  const hasSpecialCharacter = /[^\w]/g.test(password);

  useEffect(() => {
    onValidate(hasCharcters && hasNumber && hasLowerCase && hasUpperCase && hasSpecialCharacter);
  }, [hasCharcters, hasNumber, hasLowerCase, hasUpperCase, hasSpecialCharacter]);

  return (
    <ul className={styles.passwordRequirments}>
      <li>{t('title', { defaultValue: 'Your password must include at least:' })}</li>

      <li>
        <Icon
          icon="check"
          size="sm"
          color={hasUpperCase ? 'primary-purple' : 'medium-dark'}
          width="auto"
          position="left"
        />{' '}
        {t('uppercase', { defaultValue: '1 Uppercase Letter' })}
      </li>

      <li>
        <Icon
          icon="check"
          size="sm"
          color={hasLowerCase ? 'primary-purple' : 'medium-dark'}
          width="auto"
          position="left"
        />{' '}
        {t('lowercase', { defaultValue: '1 Lowercase Letter' })}
      </li>

      <li>
        <Icon
          icon="check"
          size="sm"
          color={hasNumber ? 'primary-purple' : 'medium-dark'}
          width="auto"
          position="left"
        />{' '}
        {t('number', { defaultValue: '1 Number' })}
      </li>

      <li>
        <Icon
          icon="check"
          size="sm"
          color={hasSpecialCharacter ? 'primary-purple' : 'medium-dark'}
          width="auto"
          position="left"
        />{' '}
        {t('specialCharacter', { defaultValue: '1 Special Character *@!#%&()^~{}' })}
      </li>

      <li>
        <Icon
          icon="check"
          size="sm"
          color={hasCharcters ? 'primary-purple' : 'medium-dark'}
          width="auto"
          position="left"
        />{' '}
        {t('length', { defaultValue: '8 characters' })}
      </li>
    </ul>
  );
}
